import Sortable from "sortablejs";

class EntitySelectorExport {

    constructor(elem) {
        this.elem = elem;
        this.search = '';
        this.lastClick = 0;
        this.selectedItemData = null;

        const entityTypes = elem.hasAttribute('entity-types') ? elem.getAttribute('entity-types') : 'page,book,chapter';
        const entityPermission = elem.hasAttribute('entity-permission') ? elem.getAttribute('entity-permission') : 'view';
        const entitySlug = elem.hasAttribute('entity-slug') ? elem.getAttribute('entity-slug') : '';

        this.searchUrl = window.baseUrl(`/ajax/search/entities?for_export=yes&types=${encodeURIComponent(entityTypes)}&permission=${encodeURIComponent(entityPermission)}&slug=${encodeURIComponent(entitySlug)}`);

        // this.input = elem.querySelector('[entity-selector-input]');
        // this.searchInput = elem.querySelector('[entity-selector-search]');
        this.loading = elem.querySelector('[entity-selector-loading]');
        this.resultsContainer = elem.querySelector('[entity-selector-export-results]');
        this.addButton = elem.querySelector('[entity-selector-add-button]');
        this.elem.addEventListener('click', this.onClick.bind(this));

        // let lastSearch = 0;
        // this.searchInput.addEventListener('input', event => {
        //     lastSearch = Date.now();
        //     this.showLoading();
        //     setTimeout(() => {
        //         if (Date.now() - lastSearch < 199) return;
        //         this.searchEntities(this.searchInput.value);
        //     }, 200);
        // });

        // this.searchInput.addEventListener('keydown', event => {
        //     if (event.keyCode === 13) event.preventDefault();
        // });

        if (this.addButton) {
            this.addButton.addEventListener('click', event => {
                if (this.selectedItemData) {
                    this.confirmSelection(this.selectedItemData);
                    this.unselectAll();
                }
            });
        }

        this.showLoading();
        this.initialLoad(elem);
    }

    showLoading() {
        this.loading.style.display = 'block';
        this.resultsContainer.style.display = 'none';
    }

    hideLoading() {
        this.loading.style.display = 'none';
        this.resultsContainer.style.display = 'block';
        let checkboxes = this.elem.querySelectorAll('.export-checkbox');
        let $this = this;
        checkboxes.forEach(function(checkbox) {
            checkbox.addEventListener('change', function() {  
                if(this.classList.contains('checked')){
                    if(typeof this.id != 'undefined' && this.id != ""){
                        let checkboxesChild = $this.elem.querySelectorAll('.' + this.id);
                        checkboxesChild.forEach(function(checkboxChild) {
                            checkboxChild.checked = false;
                            checkboxChild.classList.remove('checked');
                        })
                    }
                    else {
                        let checkboxesChild = $this.elem.querySelectorAll('.' + this.classList[1]);

                        let countCheckedChild = 0;
                        checkboxesChild.forEach(function (checkboxChild) {
                            if (checkboxChild.checked) {
                                countCheckedChild++;
                            }
                        })

                        if (countCheckedChild == 0) {
                            let parentCheckboxId = this.classList[1];
                            let checkboxParent = $this.elem.querySelector('#' + parentCheckboxId);
                            if (checkboxParent) {
                                checkboxParent.checked = false;
                                checkboxParent.classList.remove('checked');
                            }
                        }
                    }
                    this.classList.remove('checked');
                }else{
                    if(typeof this.id != 'undefined' && this.id != ""){
                        let checkboxesChild = $this.elem.querySelectorAll('.' + this.id);
                        checkboxesChild.forEach(function(checkboxChild) {
                            checkboxChild.checked = true;
                            checkboxChild.classList.add('checked');
                        })
                    }
                    else {
                        let parentCheckboxId = this.classList[1];
                        let checkboxParent = $this.elem.querySelector('#' + parentCheckboxId);
                        if (checkboxParent) {
                            checkboxParent.checked = true;
                            checkboxParent.classList.add('checked');
                        }
                    }
                    this.classList.add('checked');
                }
                
            })
        });
    }

    initialLoad(elem) {
        window.$http.get(this.searchUrl).then(resp => {
            this.resultsContainer.innerHTML = resp.data;
            const initialSortBox = elem.querySelector('.sort-box');
            if ( initialSortBox ) {
                this.setupBookSortable(initialSortBox);
            }

            var acc = document.getElementsByClassName("export-popup-chapter-accordion");
            var i;
            for (i = 0; i < acc.length; i++) {
                acc[i].addEventListener("click", function () {
                    this.classList.toggle("active");
                    var panel = this.parentElement.nextElementSibling;
                    if (panel.style.display === "block") {
                        panel.style.display = "none";
                        this.innerHTML = '<i class="fa fa-angle-down" aria-hidden="true"></i>';
                    } else {
                        panel.style.display = "block";
                        this.innerHTML = '<i class="fa fa-angle-up" aria-hidden="true"></i>';
                    }
                });
            }

            this.hideLoading();
        })
    }

    searchEntities(searchTerm) {
        this.input.value = '';
        let url = `${this.searchUrl}&term=${encodeURIComponent(searchTerm)}`;
        window.$http.get(url).then(resp => {
            this.resultsContainer.innerHTML = resp.data;
            this.hideLoading();
        });
    }

    isDoubleClick() {
        let now = Date.now();
        let answer = now - this.lastClick < 300;
        this.lastClick = now;
        return answer;
    }

    onClick(event) {
        const listItem = event.target.closest('[data-entity-type]');
        if (listItem) {
            event.preventDefault();
            event.stopPropagation();
            this.selectItem(listItem);
        }
    }

    selectItem(item) {
        const isDblClick = this.isDoubleClick();
        const type = item.getAttribute('data-entity-type');
        const id = item.getAttribute('data-entity-id');
        const isSelected = (!item.classList.contains('selected') || isDblClick);

        this.unselectAll();
        this.input.value = isSelected ? `${type}:${id}` : '';

        const link = item.getAttribute('href');
        const name = item.querySelector('.entity-list-item-name').textContent;
        const data = {id: Number(id), name: name, link: link};

        if (isSelected) {
            item.classList.add('selected');
            this.selectedItemData = data;
        } else {
            window.$events.emit('entity-select-change', null)
        }

        if (!isDblClick && !isSelected) return;

        if (isDblClick) {
            this.confirmSelection(data);
        }
        if (isSelected) {
            window.$events.emit('entity-select-change', data)
        }
    }

    confirmSelection(data) {
        window.$events.emit('entity-select-confirm', data);
    }

    unselectAll() {
        let selected = this.elem.querySelectorAll('.selected');
        for (let selectedElem of selected) {
            selectedElem.classList.remove('selected', 'primary-background');
        }
        this.selectedItemData = null;
    }

    /**
     * Setup the given book container element to have sortable items.
     * @param {Element} bookContainer
     */
    setupBookSortable(bookContainer) {
        const sortElems = [bookContainer.querySelector('.sort-list')];
        sortElems.push(...bookContainer.querySelectorAll('.export-list-item-chapter + ul'));

        const bookGroupConfig = {
            name: 'book',
            pull: ['book', 'chapter'],
            put: ['book', 'chapter'],
        };

        const chapterGroupConfig = {
            name: 'chapter',
            pull: ['book', 'chapter'],
            put: function (toList, fromList, draggedElem) {
                return draggedElem.getAttribute('data-type') === 'page';
            }
        };

        for (let sortElem of sortElems) {
            new Sortable(sortElem, {
                group: sortElem.classList.contains('sort-list') ? bookGroupConfig : chapterGroupConfig,
                animation: 150,
                fallbackOnBody: true,
                swapThreshold: 0.65,
                // onSort: this.updateMapInput.bind(this),
                dragClass: 'bg-white',
                ghostClass: 'primary-background-light',
                multiDrag: true,
                multiDragKey: 'CTRL',
                selectedClass: 'sortable-selected',
            });
        }
    }
}

export default EntitySelectorExport;